/* eslint-disable react/prop-types */
/* eslint-disable class-methods-use-this */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import User from '../../assets/User123.png';
import { afterLogOut } from '../../utils/logout';

const Header = ({ data }) => (
  <header>
    <h1 className="logo">
      El Camino Real Charter High School - Online Forms
    </h1>
    <aside>
      <span className="user">
        <div className="student_photo">
          <span>
            {data.student_photo_url === ''
              || data.student_photo_url === undefined
              || data.student_photo_url === null
              ? <img src={User} alt="profile_img" />
              : (
                <img
                  src={data.student_photo_url}
                  alt="profile_img"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = User;
                  }}
                />
              )}
          </span>
        </div>
        {data.first_name}
        {' '}
        {data.last_name}
        {' '}
      </span>
      <Link
        className="action"
        to="/login"
        onClick={afterLogOut}
        style={{ paddingLeft: '15px' }}
      >
        <FontAwesomeIcon
          icon={faPowerOff}
          style={{
            position: 'absolute',
            marginLeft: '-15px',
            marginTop: '3px',
          }}
        />
        log out
      </Link>
    </aside>
  </header>
);

export default Header;
